__turbopack_context__.v({
  "accordion": "_2pqE6G_accordion",
  "caret": "_2pqE6G_caret",
  "emptyAttendeeItemList": "_2pqE6G_emptyAttendeeItemList",
  "expanded": "_2pqE6G_expanded",
  "header": "_2pqE6G_header",
  "headerAttendeeTotal": "_2pqE6G_headerAttendeeTotal",
  "headerContainer": "_2pqE6G_headerContainer",
  "headerItemsCount": "_2pqE6G_headerItemsCount",
  "headerLeft": "_2pqE6G_headerLeft",
});
